// extracted by mini-css-extract-plugin
module.exports = {"search":"y0_up"};